import { useEffect } from 'react';

type AnalyticsPageViewProps = {
  endpoint?: string;
  companyId?: string;
  assetId?: string;
  memberKey?: string | null;
  clientApiToken?: string;
  recordSessionReplay?: boolean;
  defaultOptOutPiiTracking?: boolean;
  preview?: boolean;
};

export function AnalyticsPageView({
  endpoint,
  companyId,
  assetId,
  memberKey,
  clientApiToken,
  recordSessionReplay,
  defaultOptOutPiiTracking,
  preview,
}: AnalyticsPageViewProps) {
  useEffect(() => {
    if (preview || !endpoint || !companyId || !assetId || !clientApiToken) {
      return;
    }

    void import('@mutiny-pkg/analytics-tracker/src/index')
      .then(({ init }) => {
        init({
          endpoint,
          companyId,
          assetId,
          memberKey,
          clientApiToken,
          recordSessionReplay,
          defaultOptOutPiiTracking,
        });
      })
      .catch(() => {
        // Tracking must never break published page rendering.
      });
  }, [assetId, clientApiToken, companyId, defaultOptOutPiiTracking, endpoint, memberKey, preview, recordSessionReplay]);

  return null;
}
